<template>
  <v-dialog v-model="dialog" width="500">
    <v-card width="500">
      <v-card-title class="text-h6 white--text third">
        <span class="d-flex justify-left flex-grow-1">Sélectionnez Un Chevaux</span>
        <v-icon size="28" color="white" class="justify-end" @click="closeModal">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="mt-2">
        <HorseTableFilter class="pa-2" :show-item-in-chips="false" />
        <v-autocomplete
          v-model="selectHorse"
          color="grey"
          hide-details
          clearable
          prepend-inner-icon="mdi-magnify"
          label="Recherche"
          :items="getAvailableHorses"
          item-text="horse_name"
          item-value="uuid"
          :return-object="true"
          @input="updateSearchInput"
        >
          <template #prepend-item>
            <v-row v-if="getAvailableHorses.length" no-gutters justify="center" class="text-center px-4">
              <v-col cols="6">
                Nom
              </v-col>
              <v-col cols="3" class="text-body-2 text-break">
                Effort quotidien
              </v-col>
              <v-col cols="3" class="text-body-2 text-break">
                Effort hebdomadaire
              </v-col>
            </v-row>
          </template>
          <template #item="{ item }">
            <v-row no-gutters style="border-bottom: 1px solid #EEEEEE;" justify="center" class="text-center">
              <v-col class="text-body-2" cols="6">
                {{ item.horse_name }}
              </v-col>
              <v-col class="light-pink-bg text-center" cols="3">
                {{ contentTypeWeeklyEffort(item).dailyEffort }}
              </v-col>
              <v-col class="dark-pink-bg text-center" cols="3">
                {{ contentTypeWeeklyEffort(item).weeklyEffort }}
              </v-col>
            </v-row>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { inject, computed, onBeforeMount, provide, ref } from '@vue/composition-api';
import { endOfDay, startOfDay, format, fromUnixTime } from 'date-fns';
import { getSessionsByPeriod } from '@/helpers/amplify';
import { availableHorses, computeEffort, filterHorse } from '@/helpers/dataManager';
import { minutesToHours } from '@/helpers/utils';
import store from '@/store';

import HorseTableFilter from '@/components/ParticipantHorse/HorseTableFilter.vue';

export default {
  components: { HorseTableFilter },
  setup () {
    const dialog = inject('addHorseDialog');
    const session = inject('selectedSession');
    const addHorseToParticipant = inject('addHorseToParticipant');
    const selectHorse = inject('selectedHorse');
    const workspace = computed(() => store.getters.amplifyWorkspace);

    const horseWithoutParticipant = ref(null);
    const selectedHorseTypes = ref([]);
    const selectedLevels = ref([]);

    const getAvailableHorses = computed(() => {
      const availableHorsesForSession = availableHorses(session.value, true, true);

      return filterHorse(availableHorsesForSession, horseWithoutParticipant.value, session.value, selectedHorseTypes.value, null, selectedLevels.value);
    });

    const closeModal = () => {
      dialog.value = false;
    };

    const updateSearchInput = () => {
      selectedHorseTypes.value = [];
      addHorseToParticipant();
      closeModal();
    };

    onBeforeMount(async () => {
      const start = format(startOfDay(fromUnixTime(session.value.start_time)), 't');
      const end = format(endOfDay(fromUnixTime(session.value.start_time)), 't');
      let dailySessions = await getSessionsByPeriod(start, end, workspace.value);

      // remove current session from dailySessions
      dailySessions = dailySessions.filter(s => s.id !== session.value.id);

      const horses = availableHorses(session.value, true, true, dailySessions);

      store.commit('setAvailableHorses', horses);
    });

    const contentTypeWeeklyEffort = computed(() => item => {
      const weeklySessions = store.getters.weeklySessionsByContentType(item);
      const dailySessions = store.getters.dailySessionsByContentType(item);
      return {
        dailyEffort: minutesToHours(computeEffort(dailySessions, item)),
        weeklyEffort: minutesToHours(computeEffort(weeklySessions, item))
      };
    });

    provide('horseWithoutParticipant', horseWithoutParticipant);
    provide('selectedHorseTypes', selectedHorseTypes);
    provide('levelsList', selectedLevels);

    return { dialog, selectHorse, closeModal, getAvailableHorses, updateSearchInput, contentTypeWeeklyEffort };
  }
};
</script>
